import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './DeclarationTermsConditions.style.scss';

export const DeclarationTermsConditions = () => {
  return (
    <div className="declaration-terms-conditions">
      <DynamicContent
        configPath={REMOTE_CONFIG_PATHS.TERMS_CONDITIONS.DECLARATION}
        renderAsHtml={true}
      />
    </div>
  );
};
